import { useGetFinalQuestionsQuery, useGetQuestionSetsQuery } from "./questionSetsApiSlice"
import FinalQuestionSet from "./FinalQuestionSet"
import useAuth from "../../hooks/useAuth"
import PulseLoader from 'react-spinners/PulseLoader'
import { faAdd, faArrowAltCircleRight, faCogs } from "@fortawesome/free-solid-svg-icons"
import { Link, useParams } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
const GeneratedList = () => {
    const {groupId, questionSetId, type} = useParams()
    const {  isTeacher, isAdmin } = useAuth()
    const {
        data: finalQuestionSets,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetFinalQuestionsQuery({questionSetId}, {
        // pollingInterval: 15000,
        // refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })

    const { questionSet } = useGetQuestionSetsQuery("questionSetsList", {
        selectFromResult: ({ data }) => ({
            questionSet: data?.entities[questionSetId]
        }),
    })

    const buttons = (<div className="form__action-buttons">

    <Link   to={`/${type}/${groupId}/question-sets/${questionSetId}/generate`}>
<FontAwesomeIcon icon={faCogs} /> יצירת גרסה למשתמשים
</Link>
    {/* <Link   to={`/${type}/${groupId}/question-sets/`}>
<FontAwesomeIcon icon={faArrowAltCircleRight} /> בחזרה לשאלונים
</Link> */}
</div>)

    let content

    if (isLoading) content = <PulseLoader color={"#FFF"} />

    if (isError) {
        content =<> <p className="errmsg">{error?.data?.message}</p>{buttons}</>
    }

    if (isSuccess ) {
       



        const tableContent =  finalQuestionSets.map(finalQuestionSet => <FinalQuestionSet key={finalQuestionSet._id} finalQuestionSet={finalQuestionSet} />)

        content = (
            <>
            <div className="form__title-row" >
                <h1 className="d-flex">
                <Link  className="icon-button"  to={`/${type}/${groupId}/question-sets/`}>
<FontAwesomeIcon icon={faArrowAltCircleRight} />
</Link>
                    {questionSet?.title}  - גרסאות  </h1>
            {buttons}
                </div> 
            <table className={`table table--finalQuestionSet ${(isAdmin || isTeacher)&& "table--questionSets--admin"} `}>
                <thead className="table__thead">
                    <tr>
                        <th scope="col" className="table__th questionSet__title">שאלון</th>
                        <th scope="col" className="table__th questionSet__body">קבוצה</th>
                        <th scope="col" className="table__th questionSet__dates">מתאריך</th>
                        <th scope="col" className="table__th questionSet__actions"> עד תאריך</th>
                        <th scope="col" className="table__th questionSet__actions"> מס משתמשים</th>
                        <th scope="col" className="table__th questionSet__edit">#</th>
                    </tr>
                </thead>
                <tbody>
                    {tableContent}
                </tbody>
            </table>
            </>
        )
    }

    return content
}
export default GeneratedList